import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
//primereact
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "primereact/datatable";
import { BreadCrumb } from "primereact/breadcrumb";
import { confirmDialog } from "primereact/confirmdialog";
//components
import Panel from "../../../components/panel/panel";
import Modal from "../../../components/modal/Modal";
import Input from "../../../components/input/Input";
import ExportTable from "../../../components/button/ExportButton";
//services
import { getOrigins } from "../../../services/Crm/Settings/Origins/getOrigins";
import { postOrigin } from "../../../services/Crm/Settings/Origins/postOrigin";
//utils
import { queryClient } from "../../../utils/queryClient";
import { putOrigin } from "../../../services/Crm/Settings/Origins/putOrigin";
import { deleteOrigin } from "../../../services/Crm/Settings/Origins/deleteOrigin";
//hooks
import usePermission from "../../../hooks/usePermission";
//context
import { useAppContext } from "../../../context/AppContext";

const Origins = () => {
  usePermission("247");
  const form = useForm();
  const errors = form.formState.errors;
  const { permissions } = useAppContext();
  const [baseData, setBaseData] = useState(null);
  const [visibleOrigin, setVisibleOrigin] = useState("");
  const [tableToExport, setTableToExport] = useState(null);
  const [loadingButton, setLoadingButton] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const columns = [
    { field: "id", header: "Código" },
    { field: "name", header: "Origem" },
  ];
  const data = [
    { id: 1, name: "Facebook" },
    { id: 2, name: "Instagram" },
    { id: 3, name: "WhatsApp" },
    { id: 4, name: "Site" },
    { id: 5, name: "Consultor" },
  ];

  const { data: origins, isLoading: isLoadingOrigins } = useQuery({
    queryKey: [`origins`],
    queryFn: () => getOrigins(),
    refetchOnWindowFocus: false,
    // enabled: !!permissions?.includes("101")
  });

  const { mutateAsync: postOriginFn } = useMutation({
    mutationFn: postOrigin,
    onSuccess(res, _) {
      queryClient.setQueryData(["origins"], (data) => {
        return [...data, res.success];
      });
    },
  });

  const { mutateAsync: putOriginFn } = useMutation({
    mutationFn: putOrigin,
    onSuccess(res, _) {
      queryClient.setQueryData(["origins"], (data) => {
        const updatedData = [...data];
        const index = updatedData.findIndex(
          (item) => item.id === res.success.id
        );
        updatedData[index] = res.success;
        return updatedData;
      });
    },
  });

  const { mutateAsync: deleteOriginFn } = useMutation({
    mutationFn: deleteOrigin,
    onSuccess(res, _) {
      queryClient.setQueryData(["origins"], (data) => {
        const updatedData = [...data];
        const index = updatedData.findIndex(
          (item) => item.id === res.success.id
        );
        updatedData.splice(index, 1);
        return updatedData;
      });
    },
  });

  const onGlobalFilterChange = (e) => {
    setGlobalFilterValue(e.target.value);
  };
  const exportColumns = columns.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));
  const items = [
    {
      template: () => (
        <Link to={`/crm/settings/origins`} className="p-breadcrumb-link">
          Origens
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const addNewOrigin = async (data) => {
    const notification = toast.loading("Adicionando origem...");
    setLoadingButton(true);
    try {
      await postOriginFn(data);
      toast.update(notification, {
        render: `Origem ${data.name} adicionada com sucesso!`,
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      setVisibleOrigin(false);
      setLoadingButton(false);
    } catch (error) {
      toast.update(notification, {
        render: "Erro ao adicionar origem!",
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
      setLoadingButton(false);
    }
  };

  const editOrigin = async (data) => {
    const notification = toast.loading("Editando origem...");
    setLoadingButton(true);
    data.id = baseData.id;
    try {
      await putOriginFn(data);
      toast.update(notification, {
        render: `Origem editada com sucesso!`,
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      setVisibleOrigin(false);
      setLoadingButton(false);
    } catch (error) {
      toast.update(notification, {
        render: "Erro ao editar origem!",
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
      setLoadingButton(false);
    }
  };

  const handleDelete = (data) => {
    confirmDialog({
      message: `Deseja excluir a origem: ${data.name}?`,
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => handleDeleteOrigin(data.id),
    });
  };

  const handleDeleteOrigin = async (id) => {
    const notification = toast.loading("Deletando origem...");
    setLoadingButton(true);
    try {
      await deleteOriginFn(id);
      toast.update(notification, {
        render: `Origem deletada com sucesso!`,
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
    } catch (error) {
      toast.update(notification, {
        render: "Erro ao deletar origem!",
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
    }
  };

  useEffect(() => {
    if (baseData) {
      form.setValue("name", baseData.name);
    } else {
      form.setValue("name", "");
    }
  }, [baseData]);

  return (
    <>
      <div className="d-flex justify-content-between">
        <div className="col-md-4">
          <BreadCrumb model={items} home={home} className="breadCrumb" />
        </div>
        <div className="col-md-2">
          {permissions?.includes("248") && (
            <Button
              rounded
              icon="fa fa-plus"
              label="Nova origem"
              onClick={() => setVisibleOrigin(true)}
              className="p-inputtext-sm me-2 m-auto w-100"
            />
          )}
        </div>
      </div>

      {isLoadingOrigins ? (
        <Skeleton className="mt-4" width="100%" height={500} />
      ) : (
        <Panel mainCss="mt-4" title="Grupos de Acesso">
          <div>
            <hr className="my-4" />
            <ExportTable
              tableData={tableToExport}
              exportColumns={exportColumns}
              tabelaKey="Grupos de Acesso"
              onGlobalFilterChange={onGlobalFilterChange}
              globalFilterValue={globalFilterValue}
            />
            <DataTable
              stripedRows
              showGridlines
              sortMode="multiple"
              selectionMode="single"
              value={origins}
              paginator
              rows={10}
              sortableColumns={false}
              rowsPerPageOptions={[10, 25, 50]}
              // footerColumnGroup={footerGroup}
              globalFilter={globalFilterValue}
              emptyMessage="Nenhuma Informação foi encontrada."
              tableStyle={{
                minWidth: "1rem",
                fontSize: "0.8rem",
                border: "0.8rem",
              }}
            >
              {columns.map((col) => (
                <Column
                  sortable
                  key={col.field}
                  field={col.field}
                  header={col.header}
                />
              ))}
              {permissions?.includes("249") && (
                <Column
                  header="Editar"
                  body={(rowData) => (
                    <div className="text-center">
                      <Button
                        icon="fa-solid fa-pen-to-square"
                        onClick={() => {
                          setBaseData(rowData);
                          setVisibleOrigin(true);
                        }}
                      />
                    </div>
                  )}
                />
              )}
              {permissions?.includes("251") && (
                <Column
                  header="Excluir"
                  body={(rowData) => (
                    <div className="text-center">
                      <Button
                        icon="fa-solid fa-trash-can"
                        severity="danger"
                        onClick={() => handleDelete(rowData)}
                      />
                    </div>
                  )}
                />
              )}
            </DataTable>
          </div>
        </Panel>
      )}

      <Modal
        dynamicTitle="Adicionar Funil"
        position={"top-right"}
        visible={visibleOrigin}
        dynamicWidth={window.innerWidth <= 992 ? "80vw" : "25vw"}
        onHide={() => {
          setVisibleOrigin(false);
          setBaseData(null);
        }}
      >
        <form
          onSubmit={form.handleSubmit(baseData ? editOrigin : addNewOrigin)}
        >
          <div className="row">
            <div className="my-4 d-flex align-items-center">
              <Input
                name="name"
                label="Nome da Origem"
                className="w-100"
                //   defaultValue={baseData?.name}
                control={form.control}
                errors={errors}
              />
            </div>
            <div className="row justify-content-end pe-0">
              <div className="col-md-6 mx-0 pt-3 justify-content-end d-flex">
                <Button
                  rounded
                  type="submit"
                  label={baseData ? "Editar" : "Criar"}
                  iconPos="right"
                  loading={loadingButton}
                  className="p-inputtext-sm w-100"
                  icon={
                    baseData
                      ? "fa-solid fa-pen"
                      : "fa-solid fa-circle-chevron-right"
                  }
                />
              </div>
            </div>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default Origins;
